import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { Checkbox } from '../../../CiscoUi';
import { MultipleSelectOption } from '../..';
import styles from './MultipleSelectListboxOption.module.css';

export type MultipleSelectListboxOptionProps = {
  option: MultipleSelectOption;
  fieldId: string;
  isSelected: boolean;
  disabled: boolean;
  onSelect: (value: string) => void;
};

export function MultipleSelectListboxOption({
  option,
  fieldId,
  isSelected,
  disabled,
  onSelect,
}: MultipleSelectListboxOptionProps): ReactElement {
  return (
    <li
      role="option"
      aria-selected={isSelected}
      aria-disabled={disabled}
      title={option.name}
      className={classnames(styles.menuItem, {
        [styles.menuItemSelected]: isSelected,
        [styles.menuItemDisabled]: disabled,
      })}
      onClick={(event) => {
        event.preventDefault();
        if (disabled) {
          return;
        }
        onSelect(option.value);
      }}
      aria-label={option.name}
    >
      <div aria-hidden="true">
        <Checkbox
          checked={isSelected}
          disabled={disabled}
          id={`${fieldId}-${option.value}`}
          label={option.name}
          readOnly
          tabIndex={-1}
        />
      </div>
    </li>
  );
}
